import type React from 'react';

export type ZoraComponentRegistry = Readonly<Record<string, React.ElementType>>;
